import { left } from "fp-ts/lib/Either";
import type * as t from "io-ts";
import { PathReporter } from "io-ts/PathReporter";

export class TsError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class PayloadValidationError extends TsError {
  validationErrors: t.Errors;
  invalidValues: string[];
  longMessage: string;

  constructor(errors: t.Errors) {
    const invalidValues = Array.from(new Set(errors.map((err) => `'${String(err.value)}'`)));
    super(`Invalid value${invalidValues.length > 1 ? "s" : ""}: ${invalidValues.join(", ")}`);

    this.validationErrors = errors;
    this.invalidValues = invalidValues;
    this.longMessage = PathReporter.report(left(errors)).join(", ");
  }
}
